import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { Association } from "@/types";

export type AssociationTheme = {
  customThemeColor1: string | null;
  customThemeColor2: string | null;
  customThemeColor3: string | null;
};

interface AssociationStore {
  association: Association | null;
  associationId: number;
  theme: AssociationTheme | null;
  setAssociation: (association: Association) => void;
  clearAssociation: () => void;
}

export const useAssociationStore = create<AssociationStore>()(
  devtools(
    (set) => ({
      association: null,
      associationId: 0,
      theme: null,
      setAssociation: (association) =>
        set(
          {
            association,
            associationId: association?.Id ?? 0,
            theme: {
              customThemeColor1: association.CustomThemeColor1 ?? null,
              customThemeColor2: association.CustomThemeColor2 ?? null,
              customThemeColor3: association.CustomThemeColor3 ?? null,
            },
          },
          false,
          "association/setAssociation"
        ),
      clearAssociation: () =>
        set(
          { association: null, associationId: 0, theme: null },
          false,
          "association/clearAssociation"
        ),
    }),
    {
      name: "jood/association",
      enabled: process.env.NODE_ENV === "development",
    }
  )
);
